module.exports = __webpack_public_path__ + "media/src/images/icons/footer/footer-rules-095229725ff3a3fef897ae3405921e99.svg";